export const languages = state => state.languages

export const getLanguageByCode = state => (code) => {
  if (code !== null && state.languages[code] !== undefined) {
    return state.languages[code]
  } else {
    return null
  }
}